import { fabric } from 'fabric'
import { saveCropImageDetails, cropSelectedImage } from '../helpers/helper';
import { showSnackbar } from '../utils/snackbar';

export function cropImage(canvas, options) {
    const activeObject = canvas.getActiveObject();

    // Checking selected element is image
    if (activeObject?.type !== 'image') {
        showSnackbar("Please select images to crop!");
        return;
    }

    // Creating cropping tool over the image.
    const selectionRect = new fabric.Rect({
        left: activeObject.left,
        top: activeObject.top,
        width: activeObject.width * activeObject.scaleX,
        height: activeObject.height * activeObject.scaleY,
        fill: 'transparent',
        stroke: 'white',
        strokeWidth: 2,
        strokeDashArray: [20, 10],
        originX: activeObject.originX,
        originY: activeObject.originY,
        shadow: {
            color: 'rgba(0,0,0,0.6)',
            blur: 10,
            offsetX: 1,
            offsetY: 1
        }
    });


    // Adding tool into the canvas
    canvas.add(selectionRect);

    // Deselecting the existing image
    canvas.discardActiveObject();

    // Selecting the new crop element
    canvas.setActiveObject(selectionRect);


    // Add event listener for the scaled event
    selectionRect.on('scaling', function (options) {
        var obj = options.transform.target;
        var newWidth = obj.width * obj.scaleX;
        var newHeight = obj.height * obj.scaleY;

        // Finalize the width and height after scaling
        obj.set({
            width: newWidth,
            height: newHeight,
            scaleX: 1,
            scaleY: 1
        });

        activeObject.filters.push(new fabric.Image.filters.Blur({ blur: 0}));

        // Render the canvas to apply changes
        canvas.renderAll();
    });

    // Mouse up event
    canvas.on("mouse:up", function (event) {
        canvas.renderAll();

        // Updating the object and selection data in state
        saveCropImageDetails({ mainImage: activeObject, selection: selectionRect })

    });

    // Event listener for when the selection is cleared
    canvas.on('before:selection:cleared', function() {
        cropSelectedImage()
    });

}


